export default "__VITE_ASSET__BtPZTHFo__"